import { Flex, Icon } from '@weareberyl/design-system'

const icons = {
  burger: {
    type: 'menu',
    color: 'deepPurple',
    bg: 'oyster',
  },
  cross: {
    type: 'cross',
    color: 'brick',
    bg: 'prawn',
  },
  repeat: {
    type: 'repeat',
    color: 'lake',
    bg: 'shell',
  },
  tick: {
    type: 'tick',
    color: 'pickle',
    bg: 'mint',
  },
  warning: {
    type: 'warning',
    color: 'jaffa',
    bg: 'wheat',
  },
  bikeJourney: {
    type: 'bikeJourney',
    color: 'corporate',
    bg: 'shell',
  },
  user: {
    type: 'user',
    color: 'pickle',
    bg: 'mint',
  },
  spanner: {
    type: 'spanner',
    color: 'grape',
    bg: 'turmeric',
  },
  parking: {
    type: 'parking',
    color: 'grape',
    bg: 'berylGreen',
  },
  menu: {
    type: 'menu',
    color: 'tofu',
    bg: 'corporate',
  },
  scheme: {
    type: 'scheme',
    color: 'tofu',
    bg: 'berylGreen',
  },
  star: {
    type: 'star',
    color: 'white',
    bg: 'jaffa',
  },
  sparkle: {
    type: 'sparkle',
    color: 'lake',
    bg: 'shell',
  },
}

const sizes = {
  small: 2.5,
  medium: 3.5,
  large: 4,
}

export type TabIconIcon = keyof typeof icons

const TabIcon = ({
  icon,
  size = 'large',
  overlap = false,
}: {
  icon: TabIconIcon
  size?: keyof typeof sizes
  overlap?: boolean
}) => (
  <Flex
    borderRadius="100%"
    alignItems="center"
    justifyContent="center"
    bg={icons[icon].bg}
    p={1}
    height={sizes[size] * 6}
    width={sizes[size] * 6}
    {...(overlap && { ml: '-3px' })}
  >
    <Icon
      color={icons[icon].color}
      type={icons[icon].type}
      width={sizes[size] * 3}
      height={sizes[size] * 3}
    />
  </Flex>
)

export default TabIcon
